import { useEffect, useState } from 'react';
import { isBereikbaar, volgBereikbaarheid } from './apiClient';

/**
 * Of de app de server kan bereiken.
 *
 * Twee bronnen, en dat is met opzet. `navigator.onLine` reageert direct als de
 * verbinding wegvalt, maar liegt na een herlaadactie: dan meldt de browser
 * gewoon `true` terwijl de pagina uit de cache van de service worker komt en er
 * geen bereik is. Daarom telt ook mee of de laatste API-aanroep de server
 * daadwerkelijk haalde — dat is het enige harde bewijs.
 *
 * Beide moeten goed zijn voordat de app zegt dat er verbinding is; zo is de
 * melding eerder te voorzichtig dan te optimistisch, en dat is de goede kant om
 * op te falen als iemand in de supermarkt staat.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState(
    () => (typeof navigator === 'undefined' || navigator.onLine) && isBereikbaar(),
  );

  useEffect(() => {
    const bijwerken = () => setOnline(navigator.onLine && isBereikbaar());
    window.addEventListener('online', bijwerken);
    window.addEventListener('offline', bijwerken);
    const stop = volgBereikbaarheid(bijwerken);
    bijwerken();
    return () => {
      window.removeEventListener('online', bijwerken);
      window.removeEventListener('offline', bijwerken);
      stop();
    };
  }, []);

  return online;
}
